import React from "react";

const FormInput = ({
  label,
  name,
  register,
  errors,
  placeholder = "",
  type = "text",
  maxLength,
  onInput,
  className = "",
}) => {
  return (
    <>
      {label && (
        <label className="form-label" htmlFor={name}>
          {label}
        </label>
      )}
      <input
        type={type}
        id={name}
        {...register(name)}
        className={`form-control ${errors?.[name] ? "is-invalid" : ""} ${className}`}
        placeholder={placeholder}
        maxLength={maxLength}
        onInput={onInput}
      />
      {errors?.[name] && (
        <div className="invalid-feedback">{errors[name].message}</div>
      )}
    </>
  );
};

export default FormInput;
